import React from 'react'
import { Navigate } from 'react-router'
import { useMount } from 'react-use'

import { useCurrentCompanyUser } from '@/hooks/useCurrentCompanyUser'
import useNotyf from '@/hooks/useNotyf'
import { LONG_MESSAGE_DURATION } from '@/lib/constants'
import { ROUTES } from '@/lib/routes'

interface Props {
  children: React.ReactNode
}

const CompanyAdminGuard: React.FC<Props> = ({ children }) => {
  const companyUser = useCurrentCompanyUser()

  if (companyUser?.isCompanyAdmin) {
    return children
  }

  return <PermissionDeniedRedirect />
}

const PermissionDeniedRedirect: React.FC = () => {
  const notyf = useNotyf()

  useMount(() => {
    notyf.open({
      type: 'info',
      message: 'You do not have permission to access that page.',
      duration: LONG_MESSAGE_DURATION,
    })
  })

  return <Navigate to={ROUTES.index()} />
}

export default CompanyAdminGuard
